import styled from '@emotion/styled';

const StyledFieldWrapper = styled('section')({
  maxWidth: '100%',
});

export default StyledFieldWrapper;
